import { Module } from "src/state/Module"
import * as Types from "src/state/gql/_types"

export const BlackoutModule = new Module<Types.BlackoutFragment, Types.GetBlackoutsQueryVariables, Types.Blackouts_Insert_Input>({
    sortKey: 'created_at',
})